import { render, staticRenderFns } from "./AttachmentDefaultCategoriesConfigs.vue?vue&type=template&id=ae186214&"
import script from "./AttachmentDefaultCategoriesConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentDefaultCategoriesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports